import React from 'react';
import { Row, Col } from 'react-bootstrap';
import '../Dashboard/Header/HeaderDashboard.css';

/** Static V1 header shell for marketing captures (logo only). */
const MarketingHeader = () => (
    <Row className="HeaderDashboard" style={{ margin: 0 }}>
        <Col xs={6}>
            <div
                className="Oola-Logo Black-Logo"
                style={{ cursor: 'default' }}
                aria-label="Oola Life"
            />
        </Col>
        <Col xs={6} style={{ textAlign: 'right', paddingRight: '2%' }} />
    </Row>
);

export default MarketingHeader;
